<template>
  <div class="container-fluid">
    <div class="mt-4 dropdown-job-filter">
      <h1 class="mb-4 text-dark">Take Exam: {{ exam.title }}</h1>
      <p class="mb-4 text-muted">{{ exam.description }}</p>

      <div v-for="(question, index) in exam.questions" :key="index" class="mb-5">
        <b-card class="question-card">
          <h5>Question {{ index + 1 }}</h5>
          <p class="question-text">{{ question.text }}</p>

          <!-- Render question based on type -->
          <template v-if="question.question_type === 'multiple-choice'">
            <b-form-group>
              <b-form-radio-group
                :id="`question-${index}`"
                v-model="responses[index].value"
                :options="formatOptions(question.options)"
                :name="`question-${index}`"
              ></b-form-radio-group>
            </b-form-group>
          </template>

          <template v-else-if="question.question_type === 'identification'">
            <b-form-group>
              <b-form-input
                v-model="responses[index].value"
                placeholder="Enter your answer"
                class="input-field"
              ></b-form-input>
            </b-form-group>
          </template>

          <template v-else-if="question.question_type === 'essay'">
            <b-form-group>
              <b-form-textarea
                v-model="responses[index].value"
                placeholder="Enter your essay"
                rows="4"
                class="input-field"
              ></b-form-textarea>
            </b-form-group>
          </template>
        </b-card>
      </div>

      <b-button
        variant="success"
        class="submit-button"
        :disabled="isSubmitDisabled"
        @click="submitExam"
      >
        Submit Exam
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exam: {},
      responses: [], // Holds the answers for each question
      application_exam_id: null,
    };
  },
  computed: {
    isSubmitDisabled() {
      // Disable the submit button if any question is unanswered
      return this.responses.some((response) => !response.value);
    },
  },
  async created() {
    let { id } = this.$route.params
    let { application_exam } = this.$route.query
    this.application_exam_id = application_exam;
    console.log("Exam ID:", id);
    console.log("Application Exam ID:", application_exam);
    const examId = id || null;
    if (examId, application_exam) {
      const exams = await this.fetchExamData(examId);
      const hasTakenExam = await this.takeExam(application_exam);
      if(hasTakenExam) {
        this.exam = exams
        this.application_exam_id = application_exam
        this.showToast("Exam started!", "success");
      }
    } else {
      this.showToast("Exam ID is missing.", "danger");
      this.$router.push({ name: 'Exam' })
    }
  },
  methods: {
    formatOptions(options) {
      // Ensure options are properly formatted for b-form-radio-group
      return options.map((option) => ({ text: option, value: option }));
    },
    submitExam() {
      // Prepare the exam response data
      const examResponses = {
        responses: this.responses,
        applicationExamId: this.application_exam_id,
      };

      // Create a deep clone to avoid unintended side effects
      const model = JSON.parse(JSON.stringify(examResponses));
      console.log("Submitting exam with model:", model);

      // Add a loading state for better user feedback
      // this.isLoading = true;

      this.$store
        .dispatch("exam/submitExam", model)
        .then((res) => {
          // Handle the successful response
          const { message } = res.data;

          // Show success feedback
          this.showToast(message || "Exam submitted successfully!", "success");

          // Optionally, reset the responses or navigate to another page
          this.responses = [];
          this.$router.push({ name: 'Exam' })
        })
        .catch((err) => {
          // Handle errors gracefully
          console.error("Error submitting exam:", err);
          const errorMessage =
            (err.response && err.response.data && err.response.data.message) ||
            "Failed to submit the exam. Please try again.";
          
          // Show error feedback
          this.showToast(errorMessage, "error");
        })
        .finally(() => {
          // Reset the loading state
          // this.isLoading = false;
        });
    },

    fetchExamData(id) {
      return this.$store
        .dispatch("exam/find", { id })
        .then((res) => {
          if (res.data && Array.isArray(res.data.questions)) {
            this.exam = res.data;
            this.responses = res.data.questions.map((question) => ({
              question_id: question._id,
              value: "",
            }));
            return res.data
          } else {
            this.showToast("Unexpected exam data format.", "danger");
            return false
          }
        })
        .catch((err) => {
          console.error("Error fetching exam:", err);
          this.showToast("Failed to load exam. Please try again later.", "danger");
        });
    },
    takeExam(application_exam){
      return this.$store
        .dispatch("exam/takeExam", { application_exam })
        .then((res) => {
          if(res.data && res.data.exam_taken) {
            console.log("Exam taken successfully:", res.data.exam_taken);
            return res.data.exam_taken
          } else {
            this.showToast("Unexpected exam data format.", "danger");
            console.error("Unexpected exam data format:", res.data);
            return false
          }
        })
        .catch((err) => {
          console.error("Error taking exam:", err);
          this.showToast("Failed to take exam. Please try again later.", "danger")
        })
    },
    showToast(message, variant = "info") {
      this.$bvToast.toast(message, {
        title: "Notification",
        variant,
        autoHideDelay: 5000,
        solid: true,
      });
    },
  },
};
</script>

<style scoped>
/* General styling for the page */
.container {
  background-color: #ffffff;
  padding-top: 20px;
}

h1 {
  color: #333333;
}

.question-card {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
}

.question-text {
  font-weight: bold;
}

.input-field {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  width: 100%;
}

.submit-button {
  background-color: #28a745;
  color: white;
  font-weight: bold;
  margin-top: 20px;
}

.submit-button:hover {
  background-color: #218838;
}

.text-muted {
  color: #777;
}
</style>
